import locale from '../../../utils/locale';

const yesNoData = [{display: locale('yes'), value: 'Y'}, {display: locale('no'), value: 'N'}];

const titleClearData = [
    {display: locale('Yes, there is no lien on the vehicle'), value: locale('Y')},
    {display: locale('No, there is a lien on the vehicle'), value: 'N'}
]

const signTitleData = [
    {display: locale('I have signed the title'), value: locale('Y')},
    {display: locale('I need more time'), value: 'N'}
]

const signTimeData = [
    {display: locale('2 Hours'), value: locale('2')},
    {display: locale('4 hours'), value: '4'}
]

export default [
    {
        name: 'isTitleAvailable',
        label: locale('isTitleAvailable'),
        type: 'radio',
        readable: true,
        editable: true,
        required: true,
        dataSource: yesNoData
    },
    {
        name: 'isOwnerTitle',
        label: locale('isOwnerTitle'),
        type: 'radio',
        readable: true,
        editable: true,
        required: true,
        dataSource: yesNoData
    },
    {
        name: 'actualOwnerName',
        label: locale('actualOwnerName'),
        questionLabel: locale('actualOwnerName'),
        type: 'text',
        readable: true,
        editable: true,
        required: true
    },
    {
        name: 'ownerRelation',
        label: locale('ownerRelation'),
        questionLabel: locale('ownerRelation'),
        type: 'text',
        readable: true,
        editable: true,
        required: true
    },
    {
        name: 'titleClear',
        label: locale('titleClear'),
        type: 'radio',
        readable: true,
        editable: true,
        required: true,
        dataSource: titleClearData
    },
    {
        name: 'lienInstitution',
        label: locale('lienInstitution'),
        questionLabel: locale('lienInstitution'),
        type: 'text',
        readable: true,
        editable: true,
        required: true
    },
    {
        name: 'signTitle',
        label: locale('signTitle'),
        type: 'radio',
        readable: true,
        editable: true,
        required: true,
        dataSource: signTitleData
    },
    {
        name: 'signTime',
        label: locale('signTime'),
        type: 'radio',
        readable: true,
        editable: true,
        required: true,
        dataSource: signTimeData
    },
    {
        name: 'frontPhoto',
        label: locale('frontPhoto'),
        type: 'file',
        readable: true,
        editable: true,
        required: true
    },
    {
        name: 'backPhoto',
        type: 'file',
        readable: true,
        editable: true,
        required: true
    },
    {
        name: 'vehiclePhoto',
        label: locale('vehiclePhoto'),
        type: 'file',
        readable: true,
        editable: true,
        required: true
    },

]



// WEBPACK FOOTER //
// ./src/containers/PickupForm/fieldStructure/titleDetails.js